import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChainEnum, getChainImg } from '@src/app/shared/types/wallet-chain.type';

@Component({
    selector: 'app-chain-select',
    templateUrl: './chain-select.component.html',
    styleUrls: ['./chain-select.component.less'],
})
export class ChainSelectComponent {
    @Input() enableAll = false;
    @Input() selectedChain: ChainEnum.BASE | ChainEnum.BSC | 'all' | 'sol' = ChainEnum.BASE;
    @Output() selectedChainChange = new EventEmitter<ChainEnum.BASE | ChainEnum.BSC | 'all' | 'sol'>();

    ChainEnum = ChainEnum;

    options: { label: string; value: ChainEnum | 'sol' }[] = [
        { label: 'Solana', value: 'sol' },
        { label: 'Base', value: ChainEnum.BASE },
        { label: 'BSC', value: ChainEnum.BSC },
    ];

    getChainImg(chain: ChainEnum | 'sol') {
        if (chain === 'sol') {
            return '/assets/imgs/chains/solana.png';
        }

        return getChainImg(chain);
    }
}
